import Model from '@/core/models/Model';

export default class AvailableTrainingQualification extends Model {
  resource() {
    return 'app/qualifications';
  }
}
